<template>
  <div class="sc-counter-container">
    <div
      id="sc-counter-decreaseButton"
      class="sc-counter-button"
      v-on:click="onDecrease">
        <slot name="decreaseLabel"><span class="material-icons">remove</span></slot>
    </div>
    <div class="sc-counter-value" :class="value > 0 ? 'sc-counter-green-value' : ''">{{ value }}</div>
    <div
      id="sc-counter-increaseButton"
      class="sc-counter-button"
      v-on:click="onIncrease">
        <slot name="increaseLabel"><span class="material-icons">add</span></slot>
    </div>
  </div>
</template>

<script>
import utilsMixin from '../mixins/utils'

export default {
  name: 'ScCounter',
  mixins: [utilsMixin],
  data () {
    return {
      value: 0,
      decrease: 0,
      increase: 0,
      minValue: 0,
      maxValue: 0
    }
  },
  props: {
    defaultValue: {
      type: Number,
      default: 0
    },
    decreaseValue: {
      type: Number,
      default: 1
    },
    increaseValue: {
      type: Number,
      default: 1
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: Number.POSITIVE_INFINITY
    }
  },
  mounted () {
    this.checkProps()
  },
  methods: {
    checkProps () {
      if (!this.isNullOrUndefined(this.min) && !this.isNullOrUndefined(this.max) && this.min > this.max) {
        throw Error('max must be greater than min!')
      }
      !this.isNullOrUndefined(this.defaultValue) && typeof this.defaultValue === 'number' ? this.value = this.defaultValue : this.value = 0
      !this.isNullOrUndefined(this.decreaseValue) && typeof this.decreaseValue === 'number' ? this.decrease = this.decreaseValue : this.decrease = 1
      !this.isNullOrUndefined(this.increaseValue) && typeof this.increaseValue === 'number' ? this.increase = this.increaseValue : this.increase = 1
      typeof this.min === 'number' ? this.minValue = this.min : this.minValue = 0
      typeof this.max === 'number' ? this.maxValue = this.max : this.maxValue = Number.POSITIVE_INFINITY
      if (this.value < this.min) {
        this.value = this.min
      }
      if (this.value > this.max) {
        this.value = this.max
      }
    },
    onDecrease () {
      const tempValue = this.value - this.decrease
      const oldValue = this.value
      if (tempValue >= this.minValue) {
        this.value = tempValue
      } else {
        this.value = this.minValue
      }
      if (this.value === oldValue) return
      this.emitChange()
      this.$emit('decrease', this.value)
    },
    onIncrease () {
      const tempValue = this.value + this.increase
      const oldValue = this.value
      if (tempValue <= this.maxValue) {
        this.value = tempValue
      } else {
        this.value = this.maxValue
      }
      if (this.value === oldValue) return
      this.emitChange()
      this.$emit('increase', this.value)
    },
    emitChange () {
      this.$emit('change', this.value)
    }
  },

  watch: {
    defaultValue: {
      immediate: true,
      handler (newVal, oldVal) {
        this.value = newVal
      }
    }
  }
}
</script>

<style scoped lang="scss">
.sc-counter-container {
  display: inline-flex;
}
.sc-counter-button {
  background-color: $sc-counter-button-bg;
  color: $sc-counter-button-color;
  width: $sc-counter-button-width;
  height: $sc-counter-height;
  border-radius: $sc-counter-button-border-radius;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  transition: background-color 0.2s;

  span {
    font-size: $sc-counter-button-font-size;
  }

  &:hover {
    background-color: $sc-counter-button-bg-hover;
  }
}
.sc-counter-value {
  color: $sc-counter-value-default-color;
  margin: 0px 5px;
  height: $sc-counter-height;
  width: $sc-counter-value-width;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: $sc-counter-value-font-size;
}

.sc-counter-green-value {
  color: $sc-counter-value-non-default-color
}
</style>
